export const SmartCallFlowDisabledWarningText =
  "Smart Call Flow is disabled. This inbox can't receive inbound calls until it's turned back on."
